import React, { memo } from 'react';
import { Route, Switch } from 'react-router-dom';
import SpecificationsDashboard from 'containers/Specifications';
import SpecificationDetails from 'containers/Specifications/SpecificationDetails/SpecificationDetails';
import SpecificationDocument from 'views/SpecificationDocument';
function SpecificationsRouts({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: url },
            React.createElement(SpecificationsDashboard, { url: url })),
        React.createElement(Route, { path: `${url}/details/:modelSpecificationId/:tab` },
            React.createElement(SpecificationDetails, null)),
        React.createElement(Route, { path: `${url}/details/:modelSpecificationId` },
            React.createElement(SpecificationDetails, null)),
        React.createElement(Route, { path: `${url}/pdf-components/:modelSpecificationId` },
            React.createElement(SpecificationDocument, { includeComponents: true })),
        React.createElement(Route, { path: `${url}/pdf/:modelSpecificationId` },
            React.createElement(SpecificationDocument, null)),
        React.createElement(Route, { path: url },
            React.createElement(SpecificationsDashboard, { url: url }))));
}
export default memo(SpecificationsRouts);
